import { interceptConnections } from '../helpers/intercept-connections';
export var createWrapAudioScheduledSourceNodeStopMethodConsecutiveCalls = function createWrapAudioScheduledSourceNodeStopMethodConsecutiveCalls(createNativeAudioNode) {
  return function (nativeAudioScheduledSourceNode, nativeContext) {
    var nativeGainNode = createNativeAudioNode(nativeContext, function (ntvCntxt) {
      return ntvCntxt.createGain();
    });
    nativeAudioScheduledSourceNode.connect(nativeGainNode);

    var disconnectGainNode = function (disconnect) {
      return function () {
        // @todo TypeScript cannot infer the overloaded signature with 1 argument yet.
        disconnect.call(nativeAudioScheduledSourceNode, nativeGainNode);
        nativeAudioScheduledSourceNode.removeEventListener('ended', disconnectGainNode);
      };
    }(nativeAudioScheduledSourceNode.disconnect);

    nativeAudioScheduledSourceNode.addEventListener('ended', disconnectGainNode);
    interceptConnections(nativeAudioScheduledSourceNode, nativeGainNode);

    nativeAudioScheduledSourceNode.stop = function (stop) {
      var isStopped = false;
      return function () {
        var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        if (isStopped) {
          try {
            stop.call(nativeAudioScheduledSourceNode, when);
          } catch (_a) {
            nativeGainNode.gain.setValueAtTime(0, when);
          }
        } else {
          stop.call(nativeAudioScheduledSourceNode, when);
          isStopped = true;
        }
      };
    }(nativeAudioScheduledSourceNode.stop);
  };
};